/*
  https://github.com/zebzhao/Angular-QueryBuilder
*/
import { Field } from 'ngx-angular-query-builder';
import { FilterOperators, FieldMetadata, FieldMetadataCollection, FilterFieldProvider } from '../../common/filter/filtering';
import { DiaryDetailTypes } from '../constants/diary-detail-types';
import * as DiaryTypes from '../../common/enums/diaryType';

export class AdminDiaryEventFilterFieldProvider implements FilterFieldProvider {

  readonly fieldMetaDataCollection: FieldMetadataCollection;

  constructor() {

    this.fieldMetaDataCollection = new FieldMetadataCollection();
    this.initialiseFields();
  }

  private initialiseFields() {

    const eventTypes: string[] = [
      DiaryDetailTypes.Expiry, DiaryDetailTypes.Option, DiaryDetailTypes.Review, DiaryDetailTypes.Other
    ];

    const clientParentRef = { name: 'Client Parent', type: 'number', operators: FilterOperators.AdminScalar };
    this.fieldMetaDataCollection.set(clientParentRef.name, new FieldMetadata('ClientParentRef', clientParentRef)
    );

    const eventType = {
      name: 'Event Type',
      type: 'category',
      operators: FilterOperators.CategoryDefaults,
      options: this.getQueryBuilderCategories(eventTypes)
    };
    this.fieldMetaDataCollection.set(eventType.name, new FieldMetadata('EventType', eventType));

    const diaryTypes: string[] = [
      DiaryTypes.CLIENT, DiaryTypes.PROPERTY, DiaryTypes.UNIT, DiaryTypes.HEADLEASE, DiaryTypes.LEASE
    ];
    const diaryType = {
      name: 'Diary Type',
      type: 'category',
      operators: FilterOperators.CategoryDefaults,
      options: this.getQueryBuilderCategories(diaryTypes)
    };

    this.fieldMetaDataCollection.set(diaryType.name, new FieldMetadata('Entity', diaryType));

  }

  private getQueryBuilderCategories(array: Array<string>) {
    let result = [];
    array.forEach((item) => {
      result.push({
        label: item,
        name: item,
        value: item
      });
    });

    return result;
  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }

  getFieldNameFromLabel(label: string): string {    
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

}
